export const UPDATE_ONSCREEN = 'UPDATE_ONSCREEN';

export const updateOnscreen = data => ({
  type: UPDATE_ONSCREEN,
  data,
});
